/* eslint-disable operator-linebreak */
/* eslint-disable comma-dangle */
import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import { useSelector } from 'react-redux';
import ReportMensal from 'pages/report/reportMensal/reportMensal';
import ScrollToTop from 'components/ScrollToTop';
import GreenfyIA from 'v2/pages/GreenfyAI';

import {
  Property,
  ConfirmInvite,
  SignInAdmin,
  Occurrence,
  OccurrencesList,
  Pond,
  Ponds,
  Cycle,
  Cycles,
  Parameter,
  Parameters,
  EditUser,
  NewPass,
  Measurement,
  Measurements,
  ReportProduction,
  OccurrenceReport,
  Input,
  Inputs,
  Supply,
  Supplies,
  Sample,
  Samples,
  Biomeasure,
  Biomeasures,
  Protocol,
  Protocols,
  Transfer,
  Transfers,
  Population,
  Populations,
  Analyse,
  Analysis,
  Form,
  Forms,
  Harvest,
  Harvests,
  Unity,
  CustomUnity,
  Unities,
  Error404,
  Lot,
  Lots,
  Indice,
  Workers,
  Mortality,
  Mortalities,
  Client,
  Clients,
  WaterSource,
  WaterSources,
  WaterInput,
  WaterInputs,
  Stock,
  Stocks,
  TestLot,
  TestLots,
  Waste,
  Wastes,
  Plans,
  Register,
  RegisterPSF,
  RegisterSenar,
  FirstCycle,
  FirstPond,
  FirstProperty,
  SellWithUs,
  PayBill,
  EditUserPassword,
  ReportFinance,
  ReportInput,
  Instructions,
} from './pages';
import * as Page from './pages';

function PrivateRoute({ component: Component, ...rest }) {
  const isAuthenticated = useSelector(
    (state) => state.authenticated.authenticated
  );

  return (
    <Route
      {...rest}
      render={(props) => {
        if (isAuthenticated) {
          return <Component {...props} />;
        }
        return (
          <Redirect
            to={{ pathname: '/signin', state: { from: props.location } }}
          />
        );
      }}
    />
  );
}

function PrivateRouteOn({ component: Component, ...rest }) {
  const isAuthenticated = useSelector(
    (state) => state.authenticated.authenticated
  );
  return (
    <Route
      {...rest}
      render={(props) => {
        if (!isAuthenticated) {
          return <Component {...props} />;
        }
        return (
          <Redirect to={{ pathname: '/', state: { from: props.location } }} />
        );
      }}
    />
  );
}

function Routes() {
  return (
    <>
      <ScrollToTop />
      <Switch>
        <Route exact path="/">
          <Redirect to="/home" />
        </Route>

        {/* NEW  STANDARD */}
        <PrivateRoute path="/home" component={Page.Home} />
        <PrivateRoute path="/dashboard" component={Page.Dashboard} />
        <PrivateRoute path="/report" component={Page.Dashboard} />
        <PrivateRoute path="/users" component={Page.Users} />
        <PrivateRoute path="/user/:id" component={Page.User} />
        <PrivateRoute path="/user/" component={Page.User} />
        <PrivateRoute path="/logout" component={Page.Logout} />
        <PrivateRoute path="/settings-ai" component={Page.SettingsAI} />
        <PrivateRoute path="/add-files-ai" component={Page.AddFilesAI} />
        <PrivateRoute path="/list-files-ai" component={Page.ListFilesAI} />
        <PrivateRoute path="/edit-files-ai" component={Page.AddFilesAI} />

        {/* OLD STANDARD */}
        <Route path="/invite/:invite" component={ConfirmInvite} />
        <Route path="/register" component={Register} />
        <Route path="/users/invite" component={Register} />
        <Route path="/register_psf" component={RegisterPSF} />
        <Route path="/register_senar" component={RegisterSenar} />

        <PrivateRouteOn path="/admin/signin" component={SignInAdmin} />

        <PrivateRoute path="/property" component={Property} />

        <PrivateRoute path="/first-property" component={FirstProperty} />

        <PrivateRoute path="/new-occurrence" component={Occurrence} />
        <PrivateRoute path="/occurrence/:id" component={Occurrence} />
        <PrivateRoute path="/occurrences" component={OccurrencesList} />
        <PrivateRoute path="/ponds" component={Ponds} />
        <PrivateRoute path="/pond/:id" component={Pond} />
        <PrivateRoute path="/pond" component={Pond} />
        <PrivateRoute path="/first-pond" component={FirstPond} />

        <PrivateRoute path="/cycles" component={Cycles} />
        <PrivateRoute path="/cycle/:id" component={Cycle} />
        <PrivateRoute path="/cycle" component={Cycle} />
        <PrivateRoute path="/first-cycle" component={FirstCycle} />

        <PrivateRoute path="/transfer/:id" component={Transfer} />
        <PrivateRoute path="/transfer/" component={Transfer} />
        <PrivateRoute path="/transfers" component={Transfers} />

        <PrivateRoute path="/lot/:id" component={Lot} />
        <PrivateRoute path="/lot" component={Lot} />
        <PrivateRoute path="/lots" component={Lots} />

        <PrivateRoute path="/test-lot/:id" component={TestLot} />
        <PrivateRoute path="/test-lot/" component={TestLot} />
        <PrivateRoute path="/test-lots" component={TestLots} />

        <PrivateRoute path="/population/:id" component={Population} />
        <PrivateRoute path="/population" component={Population} />
        <PrivateRoute path="/populations" component={Populations} />

        <PrivateRoute path="/parameter/:id" component={Parameter} />
        <PrivateRoute path="/parameter" component={Parameter} />
        <PrivateRoute path="/parameters" component={Parameters} />
        <PrivateRoute path="/editUser/:id" component={EditUser} />
        <PrivateRoute path="/editUser" component={EditUser} />

        <Route path="/newPass/:token" component={NewPass} />

        <PrivateRoute path="/measurement/:id" component={Measurement} />
        <PrivateRoute path="/measurement" component={Measurement} />
        <PrivateRoute path="/measurements" component={Measurements} />

        <PrivateRoute path="/occurrenceReport" component={OccurrenceReport} />
        <PrivateRoute path="/input/:id" component={Input} />
        <PrivateRoute path="/input" component={Input} />
        <PrivateRoute path="/inputs" component={Inputs} />
        <PrivateRoute path="/supply/:id" component={Supply} />
        <PrivateRoute path="/supply" component={Supply} />
        <PrivateRoute path="/supplies" component={Supplies} />
        <PrivateRoute path="/sample/:id" component={Sample} />
        <PrivateRoute path="/sample" component={Sample} />
        <PrivateRoute path="/samples" component={Samples} />
        <PrivateRoute path="/biomeasure/:id" component={Biomeasure} />
        <PrivateRoute path="/biomeasure" component={Biomeasure} />
        <PrivateRoute path="/biomeasures" component={Biomeasures} />

        <PrivateRoute path="/sell-with-us" component={SellWithUs} />

        <PrivateRoute
          path="/input/:id"
          name="Alterar Alimentação"
          component={Input}
        />
        <PrivateRoute
          path="/input"
          name="Cadastrar Alimentação"
          component={Input}
        />
        <PrivateRoute
          path="/inputs"
          name="Lista de Alimentações"
          component={Inputs}
        />

        <PrivateRoute
          path="/waste/:id"
          name="Alterar Perda"
          component={Waste}
        />
        <PrivateRoute path="/waste" name="Cadastrar Perda" component={Waste} />
        <PrivateRoute
          path="/wastes"
          name="Lista de Perdas"
          component={Wastes}
        />

        <PrivateRoute
          path="/supply/:id"
          name="Alterar Insumo"
          component={Supply}
        />
        <PrivateRoute
          path="/supply"
          name="Cadastrar Insumo"
          component={Supply}
        />
        <PrivateRoute
          path="/supplies"
          name="Lista de Insumos"
          component={Supplies}
        />

        <PrivateRoute
          path="/sample/:id"
          name="Alterar Amostrar"
          component={Sample}
        />
        <PrivateRoute
          path="/sample"
          name="Cadastrar Amostrar"
          component={Sample}
        />
        <PrivateRoute
          path="/samples"
          name="Lista de Amostras"
          component={Samples}
        />

        <PrivateRoute
          path="/biomeasure/:id"
          name="Alterar Biometria"
          component={Biomeasure}
        />
        <PrivateRoute
          path="/biomeasure"
          name="Cadastrar Biometria"
          component={Biomeasure}
        />
        <PrivateRoute
          path="/biomeasures"
          name="Lista de Biometrias"
          component={Biomeasures}
        />

        <PrivateRoute path="/protocol/:id" component={Protocol} />
        <PrivateRoute path="/protocol" component={Protocol} />
        <PrivateRoute path="/protocols" component={Protocols} />

        <PrivateRoute path="/form/:id" component={Form} />
        <PrivateRoute path="/form" component={Form} />
        <PrivateRoute path="/forms" component={Forms} />

        <PrivateRoute path="/Analyse/:id" component={Analyse} />
        <PrivateRoute path="/Analysis" component={Analysis} />
        <PrivateRoute path="/Analyse" component={Analyse} />

        <PrivateRoute path="/indice/:id" component={Indice} />
        <PrivateRoute path="/indice" component={Indice} />

        <PrivateRoute path="/harvest/:id" component={Harvest} />
        <PrivateRoute path="/harvest/" component={Harvest} />
        <PrivateRoute path="/harvests" component={Harvests} />

        <PrivateRoute path="/unity/:id" component={Unity} />
        <PrivateRoute path="/unity/" component={Unity} />
        <PrivateRoute path="/custom-unit/:id" component={CustomUnity} />
        <PrivateRoute path="/custom-unit/" component={CustomUnity} />
        <PrivateRoute path="/unities" component={Unities} />

        <PrivateRoute path="/worker/:id" component={Worker} />
        <PrivateRoute path="/worker/" component={Worker} />
        <PrivateRoute path="/workers" component={Workers} />

        <PrivateRoute path="/mortality/:id" component={Mortality} />
        <PrivateRoute path="/mortality/" component={Mortality} />
        <PrivateRoute path="/mortalities" component={Mortalities} />

        <PrivateRoute path="/client/:id" component={Client} />
        <PrivateRoute path="/client/" component={Client} />
        <PrivateRoute path="/clients" component={Clients} />

        <PrivateRoute path="/water-source/:id" component={WaterSource} />
        <PrivateRoute path="/water-source/" component={WaterSource} />
        <PrivateRoute path="/water-sources" component={WaterSources} />

        <PrivateRoute path="/water-input/:id" component={WaterInput} />
        <PrivateRoute path="/water-input/" component={WaterInput} />
        <PrivateRoute path="/water-inputs" component={WaterInputs} />

        <PrivateRoute path="/stock/:id" component={Stock} />
        <PrivateRoute path="/stock/" component={Stock} />
        <PrivateRoute path="/stocks" component={Stocks} />

        <PrivateRouteOn path="/signin/:token" component={Page.SignIn} />
        <PrivateRouteOn path="/edit-user/:token" component={EditUserPassword} />
        <PrivateRouteOn path="/signin" component={Page.SignIn} />

        <PrivateRouteOn path="/admin/signin" component={Page.SignInAdmin} />
        <PrivateRoute
          path="/admin/listproperties"
          component={Page.ListProperties}
        />
        <PrivateRoute
          path="/admin/propertyChoose/:id"
          component={Page.PropertyChoose}
        />
        <Route path="/invite/:token" component={Page.ConfirmInvite} />

        <PrivateRouteOn path="/admin/signin" component={Page.SignInAdmin} />

        <PrivateRoute path="/property" component={Page.Property} />

        <PrivateRoute path="/first-property" component={Page.FirstProperty} />

        <PrivateRoute path="/new-occurrence" component={Page.Occurrence} />
        <PrivateRoute path="/occurrence/:id" component={Page.Occurrence} />
        <PrivateRoute path="/occurrences" component={Page.OccurrencesList} />
        <PrivateRoute path="/ponds" component={Page.Ponds} />
        <PrivateRoute path="/pond/:id" component={Page.Pond} />

        <PrivateRoute path="/first-pond" component={Page.FirstPond} />

        <PrivateRoute path="/cycles" component={Page.Cycles} />
        <PrivateRoute path="/cycle/:id" component={Page.Cycle} />
        <PrivateRoute path="/cycle" component={Page.Cycle} />

        <PrivateRoute path="/first-cycle" component={Page.FirstCycle} />

        <PrivateRoute path="/transfer/:id" component={Page.Transfer} />
        <PrivateRoute path="/transfer/" component={Page.Transfer} />
        <PrivateRoute path="/transfers" component={Page.Transfers} />

        <PrivateRoute path="/lot/:id" component={Page.Lot} />
        <PrivateRoute path="/lot" component={Page.Lot} />
        <PrivateRoute path="/lots" component={Page.Lots} />

        <PrivateRoute path="/population/:id" component={Page.Population} />
        <PrivateRoute path="/population" component={Page.Population} />
        <PrivateRoute path="/populations" component={Page.Populations} />

        <PrivateRoute path="/parameter/:id" component={Page.Parameter} />
        <PrivateRoute path="/parameter" component={Page.Parameter} />
        <PrivateRoute path="/parameters" component={Page.Parameters} />
        <PrivateRoute path="/editUser/:id" component={Page.EditUser} />
        <PrivateRoute path="/editUser" component={Page.EditUser} />

        <PrivateRoute path="/measurement/:id" component={Page.Measurement} />
        <PrivateRoute path="/measurement" component={Page.Measurement} />
        <PrivateRoute path="/measurements" component={Page.Measurements} />

        <PrivateRoute
          path="/occurrenceReport"
          component={Page.OccurrenceReport}
        />

        <PrivateRoute path="/input/:id" component={Page.Input} />
        <PrivateRoute path="/input" component={Page.Input} />
        <PrivateRoute path="/inputs" component={Page.Inputs} />

        <PrivateRoute path="/supply/:id" component={Page.Supply} />
        <PrivateRoute path="/supply" component={Page.Supply} />
        <PrivateRoute path="/supplies" component={Page.Supplies} />

        <PrivateRoute path="/sample/:id" component={Page.Sample} />
        <PrivateRoute path="/sample" component={Page.Sample} />
        <PrivateRoute path="/samples" component={Page.Samples} />

        <PrivateRoute path="/biomeasure/:id" component={Page.Biomeasure} />
        <PrivateRoute path="/biomeasure" component={Page.Biomeasure} />
        <PrivateRoute path="/biomeasures" component={Page.Biomeasures} />

        <PrivateRoute
          path="/input/:id"
          name="Alterar Alimentação"
          component={Page.Input}
        />
        <PrivateRoute
          path="/input"
          name="Cadastrar Alimentação"
          component={Page.Input}
        />
        <PrivateRoute
          path="/inputs"
          name="Lista de Alimentações"
          component={Page.Inputs}
        />

        <PrivateRoute
          path="/supply/:id"
          name="Alterar Insumo"
          component={Page.Supply}
        />
        <PrivateRoute
          path="/supply"
          name="Cadastrar Insumo"
          component={Page.Supply}
        />
        <PrivateRoute
          path="/supplies"
          name="Lista de Insumos"
          component={Page.Supplies}
        />

        <PrivateRoute
          path="/sample/:id"
          name="Alterar Amostrar"
          component={Page.Sample}
        />
        <PrivateRoute
          path="/sample"
          name="Cadastrar Amostrar"
          component={Page.Sample}
        />
        <PrivateRoute
          path="/samples"
          name="Lista de Amostras"
          component={Page.Samples}
        />

        <PrivateRoute
          path="/biomeasure/:id"
          name="Alterar Biometria"
          component={Page.Biomeasure}
        />
        <PrivateRoute
          path="/biomeasure"
          name="Cadastrar Biometria"
          component={Page.Biomeasure}
        />
        <PrivateRoute
          path="/biomeasures"
          name="Lista de Biometrias"
          component={Page.Biomeasures}
        />

        <PrivateRoute path="/protocol/:id" component={Page.Protocol} />
        <PrivateRoute path="/protocol" component={Page.Protocol} />
        <PrivateRoute path="/protocols" component={Page.Protocols} />

        <PrivateRoute path="/form/:id" component={Page.Form} />
        <PrivateRoute path="/form" component={Page.Form} />
        <PrivateRoute path="/forms" component={Page.Forms} />

        <PrivateRoute path="/Analyse/:id" component={Page.Analyse} />
        <PrivateRoute path="/Analysis" component={Page.Analysis} />
        <PrivateRoute path="/Analyse" component={Page.Analyse} />

        <PrivateRoute path="/indice/:id" component={Page.Indice} />
        <PrivateRoute path="/indice" component={Page.Indice} />

        <PrivateRoute path="/harvest/:id" component={Page.Harvest} />
        <PrivateRoute path="/harvest/" component={Page.Harvest} />
        <PrivateRoute path="/harvests" component={Page.Harvests} />

        <PrivateRoute path="/unity/:id" component={Page.Unity} />
        <PrivateRoute path="/unity/" component={Page.Unity} />
        <PrivateRoute path="/unities" component={Page.Unities} />

        {/* <PrivateRoute path="/worker/:id" component={Page.Worker} />
        <PrivateRoute path="/worker/" component={Page.Worker} />
        <PrivateRoute path="/workers" component={Page.Workers} /> */}

        <PrivateRoute path="/mortality/:id" component={Page.Mortality} />
        <PrivateRoute path="/mortality/" component={Page.Mortality} />
        <PrivateRoute path="/mortalities" component={Page.Mortalities} />

        <PrivateRoute path="/equipment/:id" component={Page.Equipment} />
        <PrivateRoute path="/equipment/" component={Page.Equipment} />
        <PrivateRoute path="/equipments" component={Page.Equipments} />

        <PrivateRoute
          path="/equipment-spent/:id"
          component={Page.EquipmentSpent}
        />
        <PrivateRoute
          path="/equipment-spent/"
          component={Page.EquipmentSpent}
        />
        <PrivateRoute
          path="/equipment-spents"
          component={Page.EquipmentSpents}
        />

        <PrivateRoute path="/plans" component={Plans} />

        <PrivateRoute path="/client/:id" component={Page.Client} />
        <PrivateRoute path="/client/" component={Page.Client} />
        <PrivateRoute path="/clients" component={Page.Clients} />

        <PrivateRoute path="/water-source/:id" component={Page.WaterSource} />
        <PrivateRoute path="/water-source/" component={Page.WaterSource} />
        <PrivateRoute path="/water-sources" component={Page.WaterSources} />

        <PrivateRoute path="/water-input/:id" component={Page.WaterInput} />
        <PrivateRoute path="/water-input/" component={Page.WaterInput} />
        <PrivateRoute path="/water-inputs" component={Page.WaterInputs} />

        <PrivateRoute path="/stock/:id" component={Page.Stock} />
        <PrivateRoute path="/stock/" component={Page.Stock} />
        <PrivateRoute path="/stocks" component={Page.Stocks} />

        <PrivateRoute path="/provider/:id" component={Page.Provider} />
        <PrivateRoute path="/provider/" component={Page.Provider} />
        <PrivateRoute path="/providers" component={Page.Providers} />

        <PrivateRoute path="/movement/:id" component={Page.Movement} />
        <PrivateRoute path="/movement/" component={Page.Movement} />
        <PrivateRoute path="/movements" component={Page.Movements} />

        <PrivateRoute path="/sell-with-us" component={Page.SellWithUs} />

        <PrivateRoute path="/greenfy-ai" component={GreenfyIA} />

        <PrivateRoute path="/report-production" component={ReportProduction} />

        <PrivateRoute path="/report-finance" component={ReportFinance} />
        <PrivateRoute path="/report-input" component={ReportInput} />
        <PrivateRoute path="/report-mensal" component={ReportMensal} />

        <PrivateRoute path="/sale/:id" component={Page.Sale} />
        <PrivateRoute path="/sale/" component={Page.Sale} />
        <PrivateRoute path="/sales" component={Page.Sales} />

        <PrivateRoute path="/purchase/:id" component={Page.Purchase} />
        <PrivateRoute path="/type-purchase/" component={Page.TypePurchase} />
        <PrivateRoute path="/purchase/" component={Page.Purchase} />
        <PrivateRoute path="/purchases" component={Page.Purchases} />

        <PrivateRoute path="/pay-bill/:id" component={PayBill} />
        <PrivateRoute path="/pay-bill/" component={PayBill} />
        <PrivateRoute path="/pay-bills" component={Page.PayBills} />
        <PrivateRoute path="/receive-bills" component={Page.ReceiveBills} />

        <PrivateRoute
          path="/account-center/:id"
          component={Page.AccountCenter}
        />
        <PrivateRoute path="/account-center/" component={Page.AccountCenter} />
        <PrivateRoute path="/accounts-center" component={Page.AccountsCenter} />

        <PrivateRoute path="/bank-account/:id" component={Page.BankAccount} />
        <PrivateRoute path="/bank-account/" component={Page.BankAccount} />
        <PrivateRoute path="/bank-accounts" component={Page.BankAccounts} />

        <PrivateRoute path="/cash-flow" component={Page.CashFlow} />

        <PrivateRoute path="/transaction/:id" component={Page.Transaction} />
        <PrivateRoute path="/transaction/" component={Page.Transaction} />
        <PrivateRoute path="/transactions" component={Page.Transactions} />
        <PrivateRoute path="/instructions" component={Page.Instructions} />
        {/* rota de usuários e permissões */}

        <Route component={Error404} />
      </Switch>
    </>
  );
}

export default Routes;
